import { fetchClientWebsitesList } from '@va/aaas/shared/api-client';
import { useInfiniteScrollFetch } from '@va/util/hooks';
import { useCallback } from 'react';
import { stpCounterWebsitesMapper } from '../helpers';

export const useAccountWebsitesStpData = () => {
  const websitesFetcher = useCallback(
    async ({ pageIndex, pageSize }: { pageSize: number; pageIndex: number }, controller: AbortController) => {
      const response = await fetchClientWebsitesList(
        {
          page: pageIndex,
          pageSize,
          withSubscription: true,
        },
        {
          signal: controller.signal,
        },
      );
      const intpWebsites = stpCounterWebsitesMapper(response);

      return {
        pageTotal: response.meta.pageTotal,
        items: intpWebsites,
      };
    },
    [],
  );

  const allWebsitesStpData = useInfiniteScrollFetch({
    fetcher: websitesFetcher,
    initialPagination: { pageSize: 10, pageIndex: 0 },
  });

  return { allWebsitesStpData };
};
